import { Button } from '@/design-system';
import { PresentationBranding } from './PresentationBranding';
import type { PresentationBrandingMode } from '@/domain/presentation/contracts';

export interface PresentationCoverProps {
  title: string;
  subtitle?: string;
  companyName?: string;
  logoUrl?: string;
  brandingMode: PresentationBrandingMode;
  onStart: () => void;
}

/** SPEC-011 §25-28/plan §15 — optional cover screen; "Start" opens the funnel canvas. */
export function PresentationCover({
  title,
  subtitle,
  companyName,
  logoUrl,
  brandingMode,
  onStart,
}: PresentationCoverProps) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-6 bg-bg-app px-6 text-center">
      <PresentationBranding mode={brandingMode} companyName={companyName} logoUrl={logoUrl} />
      <div>
        <h1 className="text-3xl font-semibold text-text-primary">{title}</h1>
        {subtitle ? <p className="mt-2 text-base text-text-secondary">{subtitle}</p> : null}
      </div>
      <Button onClick={onStart}>Iniciar apresentação</Button>
    </div>
  );
}
